module.exports = __webpack_public_path__ + "static/media/use3.ba862a06.jpeg";